// extracted by mini-css-extract-plugin
export default {"title":"sales-data_title__JkbGi","wrapper":"sales-data_wrapper__gbgIZ"};